module.exports = __webpack_public_path__ + "static/media/AddFile.a298efb3.svg";